module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-btn-dropdown', {
    class: _vm.klass,
    attrs: {
      "hover-reveal": false,
      "split": "",
      "label": _vm.getLabel,
      "no-hover": "",
      "no-ripple": true
    },
    on: {
      "click": _vm.click
    }
  }, [_c('q-list', {
    attrs: {
      "link": ""
    }
  }, [_c('q-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.moveLeft($event)
      }
    }
  }, [_c('q-item-main', [_c('q-item-tile', {
    attrs: {
      "label": ""
    }
  }, [_vm._v("Move left")])], 1)], 1), _vm._v(" "), _c('q-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.moveRight($event)
      }
    }
  }, [_c('q-item-main', [_c('q-item-tile', {
    attrs: {
      "label": ""
    }
  }, [_vm._v("Move right")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bde514c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DragNDrop/DragTab.vue
// module id = 1986
// module chunks = 0